import { Outlet } from "react-router-dom";
import React, { useState } from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";


export default function RootLayout() {

 const [isHomePage, setisHomePage] = useState(true);
  return (
    <div className="root-layout">
      <Header 
      isHomePage={isHomePage} />
      <main>
        <Outlet />
      </main>
      <Footer />
    </div>
  )
}